const MALL_GUIDE_END = new Date('2026-10-31T00:00:00').getTime()
const MALL_GUIDE_WEEK_KEY = 'mall_guide_week_key'

/** 以周一为起点的周标识（客户端本地时间） */
export const getWeekKey = (date = new Date()) => {
  const d = new Date(date.getFullYear(), date.getMonth(), date.getDate())
  const day = d.getDay()
  const diff = day === 0 ? -6 : 1 - day
  d.setDate(d.getDate() + diff)
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const dayNum = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${dayNum}`
}

/** 是否应展示会员商城引导弹窗：2026-10-31 前，且本周尚未弹出过 */
export const shouldShowMallGuide = () => {
  if (Date.now() >= MALL_GUIDE_END) {
    return false
  }
  const weekKey = getWeekKey()
  const last = localStorage.getItem(MALL_GUIDE_WEEK_KEY)
  return last !== weekKey
}

export const markMallGuideShown = () => {
  localStorage.setItem(MALL_GUIDE_WEEK_KEY, getWeekKey())
}
